"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { fillRule: "evenodd", d: "M8.508 13.5899c.1953.1629.492.0239.492-.2304V10h6c2.2461 0 4 1.6077 4 3.5S17.2461 17 15 17v2c3.3137 0 6-2.4624 6-5.5S18.3137 8 15 8H9V4.6405c0-.2543-.2967-.3933-.492-.2305L3.2764 8.7695a.3.3 0 0 0 0 .461l5.2314 4.3594ZM4 18c0-.5523.4477-1 1-1h9.9999v2h-10c-.5522 0-1-.4477-1-1Z", clipRule: "evenodd" })), 'UndoIcon');
